import { Button, Form } from "devextreme-react";
import { GroupItem } from "devextreme-react/form";
import { useHistory, useParams } from "react-router";
import { Tabs } from "../../../components";
import { useEffect, useRef, useState } from "react";
import { ApiResponse, verfiyResponse } from "../../../types/models/base-model";
import { useDispatch, useSelector } from "react-redux";
import { getApiParams } from "../../../redux/auth";
import { BodyType, createRequest } from "../../../redux/base/request";
import { Account, Reset } from "../types";
import { accountUrl } from "../../../services/urls";
import notify from "devextreme/ui/notify";
import loader from "../../../redux/loader";
import DetailAccountForm from "./tabs/detail";
import AccountDocumentPage from "./tabs/document";
import { getLocalized } from "../../../redux/localization";
import AccountProductPage from "./tabs/product";
import { AccountCallLogs } from "./tabs/calls";
import { AccountStoragePage } from "./tabs/location";
import { AdminAccountLocation } from "./tabs/location/type";




const AccountDetailPage = () => {
  const localize = useSelector(getLocalized);
  const history = useHistory();
  const [loading, setLoader] = useState(false);
  const dispatch = useDispatch();
  const { token, lang } = useSelector(getApiParams);
  const resetData = useRef<Reset>({
    accountId: ""
  })
  const [accountStorages, setAccountStorages] = useState<AdminAccountLocation[]>([])
  const { Id }: { Id: string } = useParams();
  const dataRef = useRef<Account>({
    AccountName: "",
    AccountType: "",
    AccountTypeId: "",
    CreateTime: "",
    Currency: "",
    CurrencyId: 1,
    Description: "",
    AccountLocations: [],
    Note : ""
  });

  const getAccountStorages = async () => {
    const response: ApiResponse<AdminAccountLocation[]> = await createRequest({
      method: "GET",
      url: "/api/admin/adminaccountstorages/get-by-account-id",
      bodyType: BodyType.formdata,
      token,
      body: { Id },
      lang,
    });
    if (verfiyResponse(response)) {
      setAccountStorages(response.Result)
    } else notify(response.Message, "error");
  };
  const request = async () => {
    const response: ApiResponse<Account> = await createRequest({
      method: "GET",
      url: accountUrl + "/" + Id,
      bodyType: BodyType.formdata,
      token,
      lang,
    });
    if (verfiyResponse(response)) {
      dataRef.current = response.Result;
      setLoader(true);
    } else notify(response.Message, "error");
  };

  const resetPassword = async () => {
    resetData.current.accountId = Id
    const response: ApiResponse<Reset> = await createRequest({
      method: "POST",
      url: "/api/admin/accounts/admin/send-reset-email",
      bodyType: BodyType.raw,
      body: resetData.current,
      token,
      lang,
    });
    if (verfiyResponse(response)) {
      notify(response.Message, "success")

    } else notify(response.Message, "error");
  }

  const confirmEmail = async () => {
    resetData.current.accountId = Id
    const response: ApiResponse<Reset> = await createRequest({
      method: "POST",
      url: "/api/admin/accounts/admin/send-vadation-email",
      bodyType: BodyType.raw,
      body: resetData.current,
      token,
      lang,
    });
    if (verfiyResponse(response)) {
      notify(response.Message, "success")

    } else notify(response.Message, "error");
  }
  useEffect(() => {
    dispatch(loader.actions.showLoader());
    request();
    dispatch(loader.actions.hideLoader());
    getAccountStorages()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form>
      <Form
        key="Id"
        visible={loading}
        labelLocation="top"
        formData={dataRef.current}
        showColonAfterLabel={true}
      >
        <GroupItem>
          <Tabs
            key="Id"
            height={700}
            children={[
              {
                title: localize.getString("accountdetails"),
                component: <DetailAccountForm data={dataRef.current} />,
              },
              {
                title: localize.getString("accountdocuments"),
                component: <AccountDocumentPage id={dataRef.current.Id} />,
              },
              {
                title: localize.getString("accountProducts"),
                component: <AccountProductPage />,
              },
              {
                title: localize.getString("callLogs"),
                component: <AccountCallLogs />,
              },
              {
                title: "Hesap Adresleri",
                component: <AccountStoragePage  data={accountStorages}/>,
              }


            ]}
          />
        </GroupItem>
      </Form>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBlockStart: 5,
          flexWrap: "wrap"
        }}
      >
        <div>
          <Button
            width={120}
            text={"Şifre Sıfırla"}
            type="success"
            stylingMode="contained"
            onClick={() => resetPassword()}
          />
          <Button
            width={210}
            text={"Doğrulama Maili Gönder"}
            type="success"
            style={{
              marginLeft: "15px"
            }}
            stylingMode="contained"
            onClick={() => confirmEmail()}
          />
        </div>
        <div style={{ display: "flex" }}>
          <Button
            width={120}
            text={"Close"}
            type="default"

            stylingMode="contained"
            onClick={() => history.goBack()}
          />
        </div>
      </div>
    </form>
  );
};
export default AccountDetailPage;
